import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { RESTRICT_MODIFY_EVENT_BEFORE_HOURS } from 'constants/booking.constants';
import messages from 'modules/booking/messages';
import ActionItemWarningIcon from 'common/components/ActionsMenu/ActionItemWarningIcon';

type TooltipMsgType =
  | 'restrictEdit'
  | 'restrictJoin'
  | 'restrictCancel'
  | 'restrictRestore'
  | 'restrictRedeem';

interface IActionItemWarningIconByTime {
  tooltipMsgType: TooltipMsgType;
  days?: number | null;
}

const ActionItemWarningIconByTime: FC<IActionItemWarningIconByTime> = ({
  tooltipMsgType,
  days,
}) => {
  const intl = useIntl();
  const hours = days ? days * 24 : RESTRICT_MODIFY_EVENT_BEFORE_HOURS;
  let tooltipMessage: string | null = null;

  if (tooltipMsgType === 'restrictEdit') {
    if (hours === 1) {
      tooltipMessage = intl.formatMessage(messages.restrictEditEventByTimeSingular);
    } else {
      tooltipMessage = intl.formatMessage(messages.restrictEditEventByTimePlural, { hours });
    }
  } else if (tooltipMsgType === 'restrictJoin') {
    if (hours === 1) {
      tooltipMessage = intl.formatMessage(messages.restrictJoinEventByTimeSingular);
    } else {
      tooltipMessage = intl.formatMessage(messages.restrictJoinEventByTimePlural, { hours });
    }
  } else if (tooltipMsgType === 'restrictCancel') {
    if (hours === 1) {
      tooltipMessage = intl.formatMessage(messages.restrictCancelEventByTimeSingular);
    } else {
      tooltipMessage = intl.formatMessage(messages.restrictCancelEventByTimePlural, { hours });
    }
  } else if (tooltipMsgType === 'restrictRestore') {
    if (hours === 1) {
      tooltipMessage = intl.formatMessage(messages.restrictRestoreEventByTimeSingular);
    } else {
      tooltipMessage = intl.formatMessage(messages.restrictRestoreEventByTimePlural, { hours });
    }
  } else if (tooltipMsgType === 'restrictRedeem') {
    tooltipMessage = intl.formatMessage(messages.restrictRedeemEventByTime);
  }

  if (!tooltipMessage) {
    return null;
  }

  return <ActionItemWarningIcon tooltipMessage={tooltipMessage} />;
};

export default ActionItemWarningIconByTime;
